'use client'

import { useEffect, useState } from 'react'

import { getSession } from 'next-auth/react'

export default function BamaSessionPing() {
  const [seconds, setSeconds] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(s => s + 1)
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const check = async () => {
    const s = await getSession()

    console.log('SESSION', s)
  }

  return (
    <button
      onClick={check}
      className='
        fixed bottom-4 right-4 z-[9999]
        h-10 w-[140px] rounded
        bg-bama-accent font-medium
        shadow hover:opacity-90
      '
    >
      Ver Sesión ({seconds}s)
    </button>
  )
}

// TODO-QA/PROD: componente auxiliar para validar refresh. Mantenerlo solo en dev.
